
<template>
  <div>
    <el-menu
      class="el-menu-demo"
      mode="horizontal"
      background-color="#334157"
      text-color="#fff"
      active-text-color="#fff"
    >
      <el-button class="buttonimg">
        <img
          class="showimg"
          :src="collapsed ? imgsq : imgshow"
          @click="toggle(collapsed)"
        />
      </el-button>
      <el-submenu index="2" class="submenu">
        <!-- <template slot="title">{{user.userRealName}}</template> -->
        <template slot="title">欢迎！{{ user.username }}</template>
        <!-- <el-menu-item index="2-1">设置</el-menu-item> -->
        <el-menu-item @click="addFormVisible = true" index="2-2"
          >添加管理员</el-menu-item
        >
        <el-menu-item @click="exit()" index="2-3">退出</el-menu-item>
      </el-submenu>
    </el-menu>

    <el-dialog
      title="添加管理员"
      :visible.sync="addFormVisible"
      width="30%"
      @click="closeDialog"
    >
      <el-form
        label-width="120px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
      >
        <el-form-item label="管理员账号" prop="username">
          <el-input
            size="small"
            v-model="editForm.username"
            auto-complete="off"
            placeholder="请输入管理员账号(2-64位)"
          ></el-input>
        </el-form-item>
        <el-form-item label="管理员密码" prop="password">
          <el-input
            size="small"
            v-model="editForm.password"
            auto-complete="off"
            placeholder="请输入管理员密码(8-128位)"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addFormVisible = false">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm()"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import { loginout } from '../api/userMG'
export default {
  name: "navcon",
  data() {
    return {
      collapsed: true,
      imgshow: require("../assets/img/show.png"),
      imgsq: require("../assets/img/sq.png"),
      user: {},
      addFormVisible: false,
      editForm: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入管理员账号", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入管理员密码", trigger: "blur" },
        ],
      },
      loading: false,
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    if (this.$store.state.user == false) {
      this.getMyInfo();
    }
    if (this.$store.state.fileBaseUrl == false) {
      this.getOss();
    }
  },
  methods: {
    getOss(){
      const date = new Date();
      this.temp = date.getTime();
      this.$request.getOss({
        fileName:this.temp
      }).then((res) => {
        this.$store.commit('setFileBaseUrl',res.data.uploadUrl)
      });
    },
    closeDialog() {
      this.addFormVisible = false;
    },
    submitForm() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$request
            .register(this.editForm)
            .then((res) => {
              this.editForm.username = "";
              this.editForm.password = "";
              this.addFormVisible = false;
              this.loading = false;
              this.$message({
                type: "success",
                message: "创建管理员账号成功！",
              });
            })
            .catch((err) => {
              this.loading = false;
              this.addFormVisible = false;
            });
        } else {
          return false;
        }
      });
    },
    // 获取个人信息
    getMyInfo() {
      this.$request.getMyInfo().then((res) => {
        this.user = res.data
        this.$store.commit("login", res.data);
      });
    },
    // 退出登录
    exit() {
      this.$confirm("退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          setTimeout(() => {
            this.$store.commit("logout", "false");
            this.$router.push({ path: "/login" });
            this.$message({
              type: "success",
              message: "已退出登录!",
            });
          }, 1000);
          // loginout()
          //   .then(res => {
          //     if (res.success) {
          //       //如果请求成功就让他2秒跳转路由
          //       setTimeout(() => {
          //         this.$store.commit('logout', 'false')
          //         this.$router.push({ path: '/login' })
          //         this.$message({
          //           type: 'success',
          //           message: '已退出登录!'
          //         })
          //       }, 1000)
          //     } else {
          //       this.$message.error(res.msg)
          //       this.logining = false
          //       return false
          //     }
          //   })
          //   .catch(err => {
          //     // 获取图形验证码
          //     this.getcode()
          //     this.logining = false
          //     this.$message.error('退出失败，请稍后再试！')
          //   })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype;
      this.$root.Bus.$emit("toggle", this.collapsed);
    },
  },
};
</script>
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}
.submenu {
  float: right;
}
.buttonimg {
  height: 60px;
  background-color: transparent;
  border: none;
}
.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}
.showimg:active {
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/navcon.vue